import React, { useState } from "react";

export const DepositCalculator = () => {
  const [calcDetails, setCalcDetails] = useState({
    scheme: "",
    amount: "",
    tenure: "",
    maturityAmount: 0,
    interestEarned: 0,
    totalInterest: 0
  });

  const [showResults, setShowResults] = useState(false);
  const [isCalculating, setIsCalculating] = useState(false);

  const calculateReturns = (e) => {
    e.preventDefault();
    setIsCalculating(true);

    let interest_rate;
    switch (calcDetails.scheme) {
      case "RDP":
        interest_rate = 5.25;
        break;
      case "SDR":
        interest_rate = 5.4;
        break;
      case "RDTAX":
        interest_rate = 5.0;
        break;
      default:
        setIsCalculating(false);
        return;
    }

    let amt = 0;
    let n = parseInt(calcDetails.tenure) / 12;
    let r = parseFloat(interest_rate) / 4;
    let p = parseFloat(calcDetails.amount);

    amt = p * Math.pow(1 + r / 100, 4 * n);
    const interestEarned = amt - p;
    
    setCalcDetails((prevState) => ({
      ...prevState,
      maturityAmount: parseFloat(amt.toFixed(2)),
      interestEarned: parseFloat(interestEarned.toFixed(2)),
      totalInterest: parseFloat((interestEarned / p * 100).toFixed(2))
    }));

    setShowResults(true);
    setIsCalculating(false);
  };

  const resetCalculator = () => {
    setCalcDetails({
      scheme: "",
      amount: "",
      tenure: "",
      maturityAmount: 0,
      interestEarned: 0,
      totalInterest: 0
    });
    setShowResults(false);
  };

  return (
    <div className="calculator-container">
      <div className="calculator-card">
        <h2>Deposit Calculator</h2>
        <p className="calculator-subtitle">Calculate potential returns on your fixed deposits</p>
        
        <form className="calculator-form" onSubmit={calculateReturns}>
          <div className="form-group">
            <label htmlFor="scheme">Deposit Scheme</label>
            <select
              name="scheme"
              id="scheme"
              onChange={(e) => {
                setCalcDetails((prevState) => ({
                  ...prevState,
                  scheme: e.target.value,
                }));
              }}
              value={calcDetails.scheme}
              required
            >
              <option value="">Select Scheme</option>
              <option value="RDP">RDP - Regular Deposit Plan (5.25%)</option>
              <option value="SDR">SDR - Special Deposit Rate (5.4%)</option>
              <option value="RDTAX">RDTAX - Tax Saving Deposit (5.0%)</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="amount">Principal Amount (₹)</label>
            <input
              type="number"
              name="amount"
              id="amount"
              placeholder="Enter principal amount"
              onChange={(e) => {
                setCalcDetails((prevState) => ({
                  ...prevState,
                  amount: e.target.value,
                }));
              }}
              value={calcDetails.amount}
              required
              min="1000"
            />
          </div>

          <div className="form-group">
            <label htmlFor="tenure">Tenure (months)</label>
            <input
              type="number"
              placeholder="Enter tenure in months"
              onChange={(e) => {
                setCalcDetails((prevState) => ({
                  ...prevState,
                  tenure: e.target.value,
                }));
              }}
              value={calcDetails.tenure}
              required
              min="1"
              max="120"
            />
          </div>

          <div className="button-group">
            <button 
              type="submit" 
              className="calculate-btn"
              disabled={isCalculating}
            >
              {isCalculating ? "Calculating..." : "Calculate Returns"}
            </button>
            
            {showResults && (
              <button 
                type="button" 
                className="reset-btn"
                onClick={resetCalculator}
              >
                Reset
              </button>
            )}
          </div>
        </form>

        {showResults && !isNaN(calcDetails.maturityAmount) && (
          <div className="results-card">
            <h3>Calculation Results</h3>
            <div className="results-grid">
              <div className="result-item">
                <span className="result-label">Principal Amount:</span>
                <span className="result-value">₹{parseFloat(calcDetails.amount).toLocaleString()}</span>
              </div>
              <div className="result-item">
                <span className="result-label">Interest Rate:</span>
                <span className="result-value">
                  {calcDetails.scheme === "RDP" ? "5.25%" : 
                   calcDetails.scheme === "SDR" ? "5.4%" : "5.0%"}
                </span>
              </div>
              <div className="result-item">
                <span className="result-label">Tenure:</span>
                <span className="result-value">{calcDetails.tenure} months</span>
              </div>
              <div className="result-item highlight">
                <span className="result-label">Interest Earned:</span>
                <span className="result-value">₹{calcDetails.interestEarned.toLocaleString()}</span>
              </div>
              <div className="result-item highlight">
                <span className="result-label">Maturity Amount:</span>
                <span className="result-value">₹{calcDetails.maturityAmount.toLocaleString()}</span>
              </div>
              <div className="result-item">
                <span className="result-label">Total Return:</span>
                <span className="result-value">{calcDetails.totalInterest}%</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
